export const environment = {
  production: false,
  projectName: "PlusDigitalDemo",
  dev: {
    REST_API_SERVER: "https://plusdigital.demo.api.testctsolution.it/api"
  },
  variables: {
    defaults: {}
  },
  customTranslationsDirectory: '/assets/custom-translations',
  defaultLang: 'it'
};
